/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { useEffect, useMemo } from 'react'
import ApexCharts from 'apexcharts'

interface iChartProps{
  id: string
  data1: number
  data2: number
  data3?: number
  onChoice?: (index: number) => void
}

export const PieChart: React.FC<iChartProps> = ({ id, data1, data2, data3, onChoice }) => {
  const series = data3
    ? useMemo(
      () =>
        [data1, data2, data3],
      [data1, data2, data3]
    )
    : useMemo(
      () =>
        [data1, data2],
      [data1, data2]
    )

  function GerarGrafico(): void {
    const options = {
      series: series,
      labels: (data3 !== null && data3 !== undefined) ? ['Preenchidos', 'Pendentes', 'Aguardando aprovação'] : ['Concluído', 'Pendente'],
      colors: (data3 !== null && data3 !== undefined) ? ['#27AE60', '#EB5757', '#FFBF2A'] : ['#27AE60', '#BBBBBB'],
      chart: {
        type: 'donut',
        height: 200,
        width: 430,
        events: {
          dataPointSelection: function(chartContext: any, seriesIndex: any, opts: any) {
            if (onChoice) {
              onChoice(opts.dataPointIndex)
            }
          }
        }
      },
      legend: {
        enabled: true,
        position: 'left'
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val: any) {
            return val.toFixed((data3 !== null && data3 !== undefined) ? 0 : 1) + ((data3 !== null && data3 !== undefined) ? '' : '%')
          }
        }
      },
      dataLabels: {
        enabled: true,
        textAnchor: 'end',
        formatter: function (val: string) {
          return parseFloat(val).toFixed(1) + '%'
        },
        style: {
          fontSize: 12,
          fontWeight: 600
        },
        dropShadow: {
          enabled: true,
          blur: 1,
          color: '#000',
          opacity: 1
        }
      },
      // plotOptions: {
      //   pie: {
      //     donut: {
      //       labels: {
      //         show: true,
      //         value: {
      //           show: true,
      //           fontSize: '22px',
      //           fontFamily: 'Helvetica, Arial, sans-serif',
      //           fontWeight: 600,
      //           offsetY: -8
      //         },
      //         total: {
      //           show: true,
      //           showAlways: true,
      //           fontSize: '0px',
      //           color: '#373d3f',
      //           formatter: function (w: any) {
      //             return '%'
      //           }
      //         }
      //       }
      //     }
      //   }
      // },
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom'
          }
        }
      }]
    }

    const chart = new ApexCharts(document.querySelector(`#${id}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [data1, data2])

  return (
        <div id={id}></div>
  )
}
